export default __webpack_public_path__ + "static/media/portfolio-4.e82f5d5d.jpg";